import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { StringUtils } from '@shared/helpers/StringUtils';
import { TipoAlergiaList } from '@shared/model/tipo-alergia-enum.model';
import { AlergiaServiceProxy, UpdateAlergiaDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-edit-alergia',
  templateUrl: './edit-alergia.component.html',
  styleUrls: ['./edit-alergia.component.scss']
})
export class EditAlergiaComponent extends AppComponentBase {
  protected alergia: UpdateAlergiaDto = new UpdateAlergiaDto();
  protected saving: boolean = false;
  protected tiposAlergias: TipoAlergiaList = new TipoAlergiaList();
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly _alergiaService: AlergiaServiceProxy,
    public bsModalRef: BsModalRef
  ) { super(injector) }

  protected save(): void {
    if (!this.isFormValided()) return;
    abp.ui.setBusy();
    this.saving = true;
    this._alergiaService.update(this.alergia).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.saving = false;
      this.onSave.emit();
      this.bsModalRef.hide();
    })
  }

  private isFormValided(): boolean {
    const validations = [
      { condition: StringUtils.isNullOrEmpty(this.alergia.substancia), message: "Informe a substância ou agente causador." },
      { condition: StringUtils.isNullOrEmpty(this.alergia.tipoAlergia), message: "Informe o tipo da alergia." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
